import axios from './axios';
import toast from 'react-hot-toast';

export const getScrappedCasingZones = async () => {
    try {
        const response = await axios({
            method: 'GET',
            url: 'scraping-casing/zones'
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const getScrapCasingTyresDataByZone = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/zone-tyres-data',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const getScrapCasingTyresDataByRegion = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/region-tyres-data',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const getScrapCasingTyresDataByHub = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/hub-tyres-data',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const downloadScrapCasingTyresByZone = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/zone-tyres-download',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const downloadScrapCasingTyresByRegion = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/region-tyres-download',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const downloadScrapCasingTyresByHub = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/hub-tyres-download',
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const getScrappedCasingRegions = async (zoneName) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `scraping-casing/regions/${zoneName}`
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};

export const getScrappedCasingFleetsHubs = async (regionName) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `scraping-casing/fleets-hubs/${regionName}`
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            'something went wrong');
        throw error;
    }
};
export const getScrappedValidatedByResource = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/validated-by-resource",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching resource report');
        throw error;
    }
};

export const getScrappedHubWiseResourceReport = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/hub-wise-resource-report",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching hub-wise report');
        throw error;
    }
};

export const getDistinctUsersReport = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "tyre-validation/distinct-users/",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching distinct users');
        throw error;
    }
};
export const getTopScrapReasons = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/top-scrap-reasons",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching scrap reasons');
        throw error;
    }
};

export const getCustomerFleets = async () => {
    try {
        const response = await axios({
            method: "GET",
            url: "customer-fleet",
            params: { limit: 3000 }
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching fleets');
        throw error;
    }
};

export const getScrapReasonFleetWise = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-reason-fleet-wise",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching fleet-wise reasons');
        throw error;
    }
};

export const getScrapTyreKmReport = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-tyre-km-report",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching KM report');
        throw error;
    }
};

export const getScrapTyreKmHubReport = async (fleetId, data) => {
    try {
        const response = await axios({
            method: "POST",
            url: `scraping-casing/scrap-tyre-km-hub-report/${fleetId}`,
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching KM hub report');
        throw error;
    }
};

export const getBilledLiftedZones = async ({ dateFrom, dateTo } = {}) => {
    try {
        const response = await axios({
            method: 'GET',
            url: 'scraping-casing/billed-lifted/zones',
            params: {
                ...(dateFrom ? { dateFrom } : {}),
                ...(dateTo ? { dateTo } : {}),
            },
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching billed zones');
        throw error;
    }
};

export const getBilledLiftedRegions = async (zoneName, { dateFrom, dateTo } = {}) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `scraping-casing/billed-lifted/regions/${zoneName}`,
            params: {
                ...(dateFrom ? { dateFrom } : {}),
                ...(dateTo ? { dateTo } : {}),
            },
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching billed regions');
        throw error;
    }
};

export const getBilledLiftedFleetsHubs = async (regionCode, { dateFrom, dateTo } = {}) => {
    try {
        const response = await axios({
            method: 'GET',
            url: `scraping-casing/billed-lifted/fleets-hubs/${regionCode}`,
            params: {
                ...(dateFrom ? { dateFrom } : {}),
                ...(dateTo ? { dateTo } : {}),
            },
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching billed fleets & hubs');
        throw error;
    }
};

export const getValidatedPendingZones = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/zones',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching validated pending zones');
        throw error;
    }
};

export const getValidatedPendingRegions = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/regions',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching validated pending regions');
        throw error;
    }
};

export const getValidatedPendingFleetsHubs = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/fleets-hubs',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching validated pending fleets & hubs');
        throw error;
    }
};

export const getValidatedPendingTyreDetails = async (data) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending-tyres-data',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching validated pending tyre details');
        throw error;
    }
};


export const getValidatedPendingZoneDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/zone-due-range-tyres',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching zone due-range tyres');
        throw error;
    }
};

/** POST body: { regionCode, dueRange, tyreStatus } */
export const getValidatedPendingRegionDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/region-due-range-tyres',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching region due-range tyres');
        throw error;
    }
};


export const getValidatedPendingHubDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/hub-due-range-tyres',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error fetching hub due-range tyres');
        throw error;
    }
};

export const downloadValidatedPendingZoneDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/zone-due-range-tyres-download',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error downloading zone due-range tyres');
        throw error;
    }
};

export const downloadValidatedPendingRegionDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/region-due-range-tyres-download',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error downloading region due-range tyres');
        throw error;
    }
};

export const downloadValidatedPendingHubDueRangeTyres = async (data = {}) => {
    try {
        const response = await axios({
            method: 'POST',
            url: 'scraping-casing/validated-pending/hub-due-range-tyres-download',
            data,
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   'Error downloading hub due-range tyres');
        throw error;
    }
};

export const getTopScrapReasonsTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/top-scrap-reasons-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching top scrap reasons tyre data');
        throw error;
    }
};

export const getScrapReasonFleetWiseTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-reason-fleet-wise-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching fleet-wise scrap reason tyre data');
        throw error;
    }
};

export const downloadTopScrapReasonsTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/top-scrap-reasons-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading top scrap reasons tyres");
        throw error;
    }
};

export const downloadScrapReasonFleetWiseTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-reason-fleet-wise-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading fleet-wise scrap reason tyres");
        throw error;
    }
};

export const getScrapTyreKmReportTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-tyre-km-report-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching KM report tyre data');
        throw error;
    }
};

export const getScrapTyreKmHubReportTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-tyre-km-hub-report-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message || 
                   error?.response?.data?.error || 
                   error?.message || 
                   'Error fetching KM hub report tyre data');
        throw error;
    }
};

export const downloadScrapTyreKmReportTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-tyre-km-report-tyre-data-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading KM report tyre data");
        throw error;
    }
};

export const downloadScrapTyreKmHubReportTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/scrap-tyre-km-hub-report-tyre-data-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading KM hub report tyre data");
        throw error;
    }
};

export const getBilledLiftedZonesTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-zones-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error fetching billed lifted zones tyre data");
        throw error;
    }
};

export const getBilledLiftedRegionsTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-regions-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error fetching billed lifted regions tyre data");
        throw error;
    }
};

export const getBilledLiftedFleetHubsTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-fleet-hubs-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error fetching billed lifted fleet hubs tyre data");
        throw error;
    }
};

export const downloadBilledLiftedZonesTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-zones-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading billed lifted zones tyres");
        throw error;
    }
};

export const downloadBilledLiftedRegionsTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-regions-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading billed lifted regions tyres");
        throw error;
    }
};

export const downloadBilledLiftedHubsTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/billed-lifted-hubs-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading billed lifted hubs tyres");
        throw error;
    }
};

export const getValidatedByResourceTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/validated-by-resource-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error fetching validated by resource tyre data");
        throw error;
    }
};

export const getHubWiseResourceTyreData = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/hub-wise-resource-tyre-data",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error fetching hub-wise resource tyre data");
        throw error;
    }
};

export const downloadValidatedByResourceTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/validated-by-resource-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading validated by resource tyres");
        throw error;
    }
};

export const downloadHubWiseResourceTyres = async (data) => {
    try {
        const response = await axios({
            method: "POST",
            url: "scraping-casing/hub-wise-resource-tyres-download",
            data
        });
        return response.data;
    } catch (error) {
        toast.error(error?.response?.data?.message ||
                   error?.response?.data?.error ||
                   error?.message ||
                   "Error downloading hub-wise resource tyres");
        throw error;
    }
};
